import { render, staticRenderFns } from "./comp_GoogleAuthButton.vue?vue&type=template&id=722c1e56&scoped=true"
import script from "./comp_GoogleAuthButton.vue?vue&type=script&lang=js"
export * from "./comp_GoogleAuthButton.vue?vue&type=script&lang=js"
import style0 from "./comp_GoogleAuthButton.vue?vue&type=style&index=0&id=722c1e56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722c1e56",
  null
  
)

export default component.exports